export default __webpack_public_path__ + "static/media/blog_inner_20.c4c0b42f.jpg";